import type { FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";

import { SequenceTile } from "../../core/tiles/index.js";
import type { Sequence } from "@/graphql.ts";

export interface IIntReferencesCardProps extends GridCard {
  title?: string;
  references: Sequence[];
}

const IntReferencesCard: FC<IIntReferencesCardProps> = (props) => {
  if (props.references.length === 0) {
    return null;
  }

  return (
    <Card
      shrinkable={props.references.length > 7}
      title={props.title ?? "Internal References"}
      tag={{ label: String(props.references.length) }}
      icon={"sticky_note_2"}
    >
      <CardRowSimple>
        {props.references.map((ref, index) => (
          <SequenceTile sequence={ref} key={`int-reference-card-${index}`} />
        ))}
      </CardRowSimple>
    </Card>
  );
};

export { IntReferencesCard };
